import { Icon } from "./Icon";

export function BrandHeader({ onSettings, onBrandTap }: { onSettings: () => void; onBrandTap: () => void }) {
  return (
    <header className="brand-header">
      <button type="button" className="brand-header__brand" onClick={onBrandTap} aria-label="NewsLens home">
        <img src="/icons/newslens-mark-192.png" alt="" width="38" height="38" />
        <span>NewsLens</span>
      </button>
      <button type="button" className="icon-button" onClick={onSettings} aria-label="Open settings"><Icon name="gear" size={28} /></button>
    </header>
  );
}
